<script setup lang="ts">
const VueQueryDevtools = import.meta.dev
  ? defineAsyncComponent(() => import('@tanstack/vue-query-devtools').then(m => m.VueQueryDevtools))
  : null

useHead({
  title: 'Avow',
  titleTemplate: (title) => {
    return title && title !== 'Avow' ? `${title} | Avow` : 'Avow'
  },
  style: [
    {
      key: 'critical-css',
      innerHTML: `html,body,#__nuxt{height:100vh;margin:0;padding:0;font-family:Montserrat,'Montserrat Fallback',ui-sans-serif,system-ui,-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,'Helvetica Neue',Arial,'Noto Sans',sans-serif}html{background-color:#f9fafb}html.dark{background-color:#030712}html.dark .app-nav-header{background-color:#030712;border-color:rgba(31,41,55,.6);color:rgba(243,244,246,1)}@keyframes shimmer{0%{transform:translateX(-100%)}100%{transform:translateX(100%)}}.group-hover\\:animate-shimmer{animation:shimmer 1.5s ease-in-out infinite}`,
    },
  ],
})
</script>

<template>
  <NuxtLayout>
    <NuxtPage />
  </NuxtLayout>
  <VueQueryDevtools v-if="VueQueryDevtools" />
</template>
